import { render, staticRenderFns } from "./AdminChats.vue?vue&type=template&id=72e61fdb&scoped=true&"
import script from "./AdminChats.vue?vue&type=script&lang=js&"
export * from "./AdminChats.vue?vue&type=script&lang=js&"
import style0 from "./AdminChats.vue?vue&type=style&index=0&id=72e61fdb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e61fdb",
  null
  
)

export default component.exports